exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".popup-container .content .ui.grid{\n  width: 200px;\n}\n.popup-container .content .ui.grid .column:hover{\n  cursor: pointer;\n  background-color: #F2F2F2;\n}\n.popup-container .content .ui.grid .column span{\n  padding-left: 10px;\n}\n.popup-container .content .popup-icon{\n  margin-top: -10px;\n}\n\n.popup-eye {\n  position: relative;\n  float: right;\n  margin-right: 0px;\n  margin-left: 0px;\n  margin-bottom: 10px;\n}\n\n.popup-cart {\n  position: relative;\n  float: right;\n  margin-right: 0px;\n  margin-left: 0px;\n  margin-bottom: 10px;\n}\n\n.popup-eye:hover {\n  color: red;\n  cursor: pointer;\n}\n", ""]);

// exports
